export interface MyInformationState {
  rootFolders;
}

export const initialState: MyInformationState = {
  rootFolders: null,
};
